import PoloPlayerOrange from "./PoloPlayerOrange.svg";
import PoloPlayerGreen from "./PoloPlayerGreen.svg";
import PoloPlayerBlue from "./PoloPlayerBlue.svg";
import PoloPlayerBrown from "./PoloPlayerBrown.svg";
import PoloPlayerLightBlue from "./PoloPlayerLightBlue.svg";
import PoloPlayerPink from "./PoloPlayerPink.svg";
import PoloPlayerPurple from "./PoloPlayerPurple.svg";
import PoloPlayerRed from "./PoloPlayerRed.svg";
import PoloPlayerYellow from "./PoloPlayerYellow.svg";
import PoloPlayerWhite from "./PoloPlayerWhite.svg";
import PoloPlayerBlack from "./PoloPlayerBlack.svg";
const PRO_COLORS = [
    ["orange", PoloPlayerOrange],
    ["green", PoloPlayerGreen],
    ["blue", PoloPlayerBlue],
    ["brown", PoloPlayerBrown],
    ["navy", PoloPlayerLightBlue],
    ["pink", PoloPlayerPink],
    ["purple", PoloPlayerPurple],
    ["red", PoloPlayerRed],
    ["yellow", PoloPlayerYellow],
    ["white", PoloPlayerWhite],
    ["black", PoloPlayerBlack]
  ]; 
export const PRO_COLORS_MAP = PRO_COLORS.reduce((acc, [color, image]) => {
  acc[color] = image;
  return acc;
}, {});
export default PRO_COLORS